export default "__VITE_ASSET__C$5NoswN__"